import { component } from 'picoapp'

export default component((node, ctx) => {
  let observerOptions = {
    rootMargin: '0px',
    threshold: 0,
  }

  var observer = new IntersectionObserver(observerCallback, observerOptions)

  function observerCallback(entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.src = entry.target.dataset.video
      } else {
        entry.target.src = null
      }
    })
  }

  observer.observe(node)
})
